const Actions = {
  FETCH_ALL_DOOR: "FETCH_ALL_DOOR",
  FETCH_ALL_DOOR_SUCCESS: "FETCH_ALL_DOOR_SUCCESS",
  FETCH_ALL_DOOR_FAILURE: "FETCH_ALL_DOOR_FAILURE",
};

export default Actions;
